module.exports = __webpack_public_path__ + "img/mind_skeleton_20.fdb08836.png";